/**
 * @generated SignedSource<<2d788d201fd1874aa0826867862a2b18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedAuctionItemsBanner_seller$data = {
  readonly sellerProfile: {
    readonly company: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "SbSharedAuctionItemsBanner_seller";
};
export type SbSharedAuctionItemsBanner_seller$key = {
  readonly " $data"?: SbSharedAuctionItemsBanner_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedAuctionItemsBanner_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedAuctionItemsBanner_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "f524f674913ffd4906f8336f88289f14";

export default node;
